import { MultimediaFileDTO } from "./multimediaFileDTO";
import { SequencePhaseDTO } from "./sequenceDTO";

export interface PlaylistDTO {
  token: string;
  name: string;
  terminalType: TerminalType;
  sequencesPerPhase: {[phase: string]: SequencePhaseDTO[]};
  createdOn: string;
  updatedOn: string;
}

export enum FileOperationStatus {
  VALIDATION_ERROR = "VALIDATION_ERROR",
  WAITING_FOR_CONVERSION = "WAITING_FOR_CONVERSION",
  CONVERSION_ERROR = "CONVERSION_ERROR",
  CONVERSION_DONE = "CONVERSION_DONE",
}

export enum TerminalType {
  SIMPLE = "SIMPLE",
  FM27 = "FM27",
  FM17_SLASH_19 = "FM17_SLASH_19",
  OPT13 = "OPT13"
}

export enum SequencePhases {
  DEFAULT = "DEFAULT",
  IDLE = 'IDLE',
  FUELLING = 'FUELLING',
  END = 'END',
}
